import '../../css/Store.css';
import AppStore from "../../../assets/app-store.png";
import PlayStore from "../../../assets/google-play.png";


export default function Store() {
  return (
    <section className="store-section py-5">
      <div className="container text-center">

        <h4 className="store-title mb-4">
          Download <span>Froth TestOps</span>
        </h4>

        <div className="d-flex flex-wrap justify-content-center align-items-center gap-4">

          {/* Google Play */}
          <a
            href="https://play.google.com/store/apps/details?id=ytlc.frothtestops.com.testops"
            target="_blank"
            rel="noopener noreferrer"
            className="store-card"
          >
            <img
              src={PlayStore}
              alt="Google Play"
              className="img-fluid"
            />
          </a>

          {/* App Store */}
          <a
            href="https://apps.apple.com/in/app/frothtestops/id6746042634"
            target="_blank"
            rel="noopener noreferrer"
            className="store-card"
          >
            <img
              src={AppStore}
              alt="App Store"
              className="img-fluid"
            />
          </a>

        </div>
      </div>
    </section>
  );
}